<div class="display-flex flex-direction-column flex-grow-1 min-height-0">
  @if (conversation.locked && conversation.locked_messages_count) {
    <sb-scrollbox #scrollbox [attach]="'end'" [class.flex-fill]="conversationStore.source === 'messages-page'">
      <div
        class="wrapper max-width-1200 mh-auto width-full pt-4@r"
        [class.flex-grow-1]="conversationStore.source === 'messages-page' && ('desktop' | breakpointAbove)"
      >
        <sb-locked-message class="max-width-700 mh-auto" [conversation]="conversation" />
      </div>
      <sb-interaction-activity-alert class="pf-4@r mh-auto" [profile]="conversation.profile" />
    </sb-scrollbox>
  } @else if (conversation.archived) {
    <div class="notes max-width-1200 mh-auto width-full display-flex flex-direction-column">
      <div class="pf-4 color-ash bg-vapor t-10@r border-radius-16@tablet text-align-center mt-4">
        This member is currently inactive. Conversation cannot be continued at this time.
      </div>
    </div>
  } @else {
    <sb-scrollbox #scrollbox [attach]="'end'" [class.flex-fill]="conversationStore.source === 'messages-page'">
      <div class="notes max-width-1200 mh-auto width-full display-flex flex-direction-column">
        @if (conversation.show_greeting_explainer) {
          <div class="mt-1@r pf-4 color-ash bg-vapor t-10@r border-radius-16@tablet text-align-center">
            Your greeting started this conversation, well done!
            <button
              sbButton
              [iconOnly]="true"
              [size]="'tiny'"
              [variant]="'fill-transparent-ash'"
              (click)="conversationUIService.openGreetingExplainerModal()"
            >
              <sb-icon [name]="'info-circle'" />
            </button>
          </div>
        }

        @if (conversationStore.messages().length < 1 && conversationStore.source === 'messages-page') {
          <sb-empty-conversation [profile]="conversation.profile" />
        }
      </div>
      <div
        class="wrapper max-width-1200 mh-auto width-full display-flex flex-direction-column"
        [class.wrapper--with-boost-spacing]="memberService.account.benefactor"
      >
        @if (conversationStore.next_cursor(); as nextCursor) {
          <button
            class="mt-1@r"
            sbButton
            [processing]="conversationStore.loadMoreInProgress()"
            [size]="'big'"
            [variant]="'ghost-cloud'"
            (click)="conversationStore.loadMoreMessages(conversation, nextCursor)"
          >
            Load more messages
          </button>
        }

        <sb-messages [conversation]="conversation" (messageChanged)="onMessageChanged()" />
      </div>
    </sb-scrollbox>

    <sb-message-form class="max-width-1200 mh-auto width-full" [conversation]="conversation" />
  }
</div>
